import { translate } from "@/plugins/i18n";
import BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";

export class EnumScannerInputType implements BaseEnumType {
  private static allValues: EnumScannerInputType[] = []; // make sure this is top-most
  
  public static unknown = new EnumScannerInputType(0, "Unknown", "enum_scanner_input_type_unknown");
  public static labelContainer = new EnumScannerInputType(1, "LabelContainer", "enum_scanner_input_type_label_container");
  public static containerNumbering = new EnumScannerInputType(2, "ContainerNumbering", "enum_scanner_input_type_container_numbering");
  public static labelling = new EnumScannerInputType(3, "Labelling", "enum_scanner_input_type_labelling");
  public static containerRacking = new EnumScannerInputType(4, "ContainerRacking", "enum_scanner_input_type_container_racking");
  public static racking = new EnumScannerInputType(5, "Racking", "enum_scanner_input_type_racking");
  public static containerOut = new EnumScannerInputType(6, "ContainerOut", "enum_scanner_input_type_container_out");
  public static delivery = new EnumScannerInputType(7, "Delivery", "enum_scanner_input_type_delivery");
  public static containerCheck = new EnumScannerInputType(8, "ContainerCheck", "enum_scanner_input_type_container_check");
  public static containerIn = new EnumScannerInputType(9, "ContainerIn", "enum_scanner_input_type_container_in");
  public static return = new EnumScannerInputType(10, "Return", "enum_scanner_input_type_return");
  public static pallet = new EnumScannerInputType(11, "Pallet", "enum_scanner_input_type_pallet");
  public static stockEntry = new EnumScannerInputType(12, "StockEntry", "enum_scanner_input_type_stock_entry");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumScannerInputType.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isUnknown() { return this === EnumScannerInputType.unknown; }
  public isLabelContainer() { return this === EnumScannerInputType.labelContainer; }
  public isContainerNumbering() { return this === EnumScannerInputType.containerNumbering; }
  public isLabelling() { return this === EnumScannerInputType.labelling; }
  public isContainerRacking() { return this === EnumScannerInputType.containerRacking; }
  public isRacking() { return this === EnumScannerInputType.racking; }
  public isContainerOut() { return this === EnumScannerInputType.containerOut; }
  public isDelivery() { return this === EnumScannerInputType.delivery; }
  public isContainerCheck() { return this === EnumScannerInputType.containerCheck; }
  public isContainerIn() { return this === EnumScannerInputType.containerIn; }
  public isReturn() { return this === EnumScannerInputType.return; }
  public isPallet() { return this === EnumScannerInputType.pallet; }
  public isStockEntry() { return this === EnumScannerInputType.stockEntry; }

  public static getValues(): readonly EnumScannerInputType[] {
    return EnumScannerInputType.allValues;
  }

  public static getValuesExcept0(): readonly EnumScannerInputType[] {
    return EnumScannerInputType.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumScannerInputType {
    const found = EnumScannerInputType.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumScannerInputType - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumScannerInputType): EnumScannerInputType {
    const found = name ? EnumScannerInputType.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumScannerInputType - Value not found: ${ name }`);
    }

    return found;
  }
}